import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="team-picker"
//
export default class extends Controller {
  static targets = ["select"]
  static values = { newRegistrationUrl: String }

  declare selectTarget: HTMLSelectElement
  declare newRegistrationUrlValue: string

  go(event: Event): void {
    event.preventDefault()

    const teamId = this.selectTarget.value
    if (!teamId) {
      window.alert("Please select team")
      return
    }

    const url = new URL(this.newRegistrationUrlValue, window.location.href)
    url.searchParams.set("team_id", teamId)
    window.location.assign(url.toString())
  }
}
